export class VehicleDetail {
    vin: string;
    brandCode: string;
    modelName: string;
    modelDescription: string;
    year: string;
    planWarranty: string;
    warrantyStatus: string;
    warrantyEndDate: Date;
    planType: string;
    planStatus: string;
    planEnd: string;
    currentPlanYears: number;
    currentPlanEndKM: number;
    deliveryDate: string;
    modelNumber: string;
    engineNumber: string;
    planStart: string;
    startKM: number;
    warrantyStartDate: Date;
    warrantyEndKM: number;
    segment: string;    // for 'just browsing'
    currentOdometer: number;
}
